import { render, staticRenderFns } from "./form-basic.vue?vue&type=template&id=9a274c4c&"
import script from "./form-basic.vue?vue&type=script&lang=js&"
export * from "./form-basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports